import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/UI/Button';
import { Box } from '@/layout';
import { Modal } from '@mui/material';

import { ModalForm, ModalTitle } from '../style';
import { successHandler, errorHandler } from '@/utils/toastHandler';
import { Close, Copy } from '@/components/Icon';
import { H4 } from '@/components/UI/Typography/Heading';
import styled from 'styled-components';
import { LinkWrapper } from '../ShareMenu/style';

interface TranscribeProps {
  shareLink: string;
  show: boolean;
  setShowShareByLinkModal: (show: boolean) => void;
}

const ShareByLinkModal = ({ shareLink, show, setShowShareByLinkModal }: TranscribeProps) => {
  // @ts-ignore
  const { t } = useTranslation();

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareLink);
    successHandler(t('success.copied'));
  };

  // 當shareLink改變時重新渲染modal內容確保最新
  useEffect(() => {}, [shareLink, show]);

  return (
    <Modal
      open={show}
      onClose={() => setShowShareByLinkModal(false)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableEnforceFocus
    >
      <ModalForm>
        <Close.ButtonClose
          type="button"
          onClick={() => {
            setShowShareByLinkModal(false);
          }}
        >
          <Close.CloseSVG />
        </Close.ButtonClose>
        <ModalTitle>Share files by link</ModalTitle>
        <Box style={{ marginBottom: '20px' }}>Anyone with the link can view and download the file.</Box>
        <LinkWrapper onClick={handleCopyLink}>
          <H4 style={{ width: 'calc(100% - 24px)', wordBreak: 'break-all' }}>{shareLink}</H4>
          <Copy.CopySVG fill={'#3C5AB1'} />
        </LinkWrapper>
        <Box style={{ marginTop: '28px', display: 'flex', alignItems: 'center' }}>
          <Button
            size={'lg'}
            variant={'primary'}
            rounded={false}
            marginRight={40}
            onClick={() => setShowShareByLinkModal(false)}
            type={'button'}
          >
            {t('buttons.ok')}
          </Button>
        </Box>
      </ModalForm>
    </Modal>
  );
};

export default ShareByLinkModal;
